$(function () {

// Note: Quantity button events (.js-qtyBtn, .qty__input) are handled by shipping-app.js
// to avoid duplicate event binding and ensure cart API updates are handled correctly

 $('.js-tab').each(function () {
      var $tabGroup = $(this);
      var $scope = $tabGroup.closest('.p-checkout__item');
      if (!$scope.length) $scope = $tabGroup.parent(); // fallback

      var $links = $tabGroup.find('ul li a');
      var $contents = $scope.find('.tab-content');

      function activateTab($link, animate) {
        var target = $link.data('tab');
        if (!target) return;

        $links.removeClass('is-active');
        $link.addClass('is-active');

        $contents.removeClass('is-active').hide();
        var $targetContent = $contents.filter('[data-tab-content="' + target + '"]');

        $targetContent.addClass('is-active');
        if (animate) $targetContent.fadeIn(150);
        else $targetContent.show();
      }

      $links.on('click', function (e) {
        e.preventDefault();
        activateTab($(this), true);
      });

      // init active:
      // nếu không có is-active => active cái đầu tiên
      var $active = $links.filter('.is-active').first();
      if (!$active.length) $active = $links.first();

      activateTab($active, false);
    });

  $('input[name="stickerOption"]').on('change', function () {
    $('.p-sticker-detail').hide();
    $('.option-card').removeClass('is-active');
    $(this).closest('.option-card').addClass('is-active');
    const val = $(this).val();
    if (val === 'ribbon') {
      $('#detailRibbon').show();
    } else if (val === 'message') {
      $('#detailMessage').show();
    }
  });
  // Bag toggle - use event delegation for dynamically rendered content
  // Bag options are always visible; toggle only updates is-active class
  $(document).on("change", '.js-bagToggle input[type="radio"]', function () {
    var $wrap = $(this).closest(".js-bagToggle");
    var val = $(this).val();

    if (val === "on") {
      $wrap.addClass("is-active");
    } else {
      $wrap.removeClass("is-active");
    }
  });

  // Bag box checkbox - use event delegation
  $(document).on("change", '.js-bagBox input[type="checkbox"]', function () {
    var $checkbox = $(this);
    var $optionCard = $checkbox.closest(".option-card");

    if ($checkbox.is(":checked")) {
      $optionCard.addClass("is-active");
    } else {
      $optionCard.removeClass("is-active");
    }
  });
  $(function () {
    $(document).on("click", ".js-packageItem .js-packageClick", function (e) {
      var $label = $(this).closest(".js-packageItem");
      $label.find('input[type="radio"]').prop("checked", true).trigger("change");
    });
  });
  $(function () {
    $(document).on("click", ".js-bagPaid .option-card__inner", function () {
      var $label = $(this).closest(".js-bagPaid");
      var $checkbox = $label.find(".option-card__checkbox");
      if ($checkbox.prop("disabled") || $label.hasClass("is-disable")) return;
      $checkbox.prop("checked", true);
    });
  });
});
// Bag toggle (modal + outside)
// $(document).on('change', '.js-bagRadio', function () {
//   var $item = $(this).closest('[data-item]');
//   var val = $(this).val(); // 0/1
//   console.log('bag change item', $item.data('item'), val);

// });

// Wrap toggle (modal + outside)
// $(document).on('change', '.js-wrapRadio', function () {
//   var $item = $(this).closest('[data-item]');
//   var val = $(this).val(); // paper/noshi/ribbon
//   console.log('wrap change item', $item.data('item'), val);
// });
//  js-bagBox


// modalBulkListAdd: checkbox toggle is-active
$(document).on("change", "#modalBulkListAdd .addr-card .option-card__checkbox", function () {
  $(this).closest(".addr-card").toggleClass("is-active", this.checked);
});

$(document).on("click", "#modalBulkListAdd .addr-card", function (e) {
  if ($(e.target).is(".option-card__checkbox")) return;
  if ($(e.target).closest("[data-edit-saved-address]").length) return;
  var $cb = $(this).find(".option-card__checkbox");
  $cb.prop("checked", !$cb.prop("checked")).trigger("change");
});

// modalChangeAddress: radio single-select is-active
$(document).on("change", "#modalChangeAddress .addr-card .option-card__radio", function () {
  var $list = $(this).closest(".address-list, [data-change-address-list]");
  $list.find(".addr-card").removeClass("is-active");
  $list.find(".option-card__radio:checked").each(function () {
    $(this).closest(".addr-card").addClass("is-active");
  });
});

$(document).on("click", "#modalChangeAddress .addr-card", function (e) {
  if ($(e.target).is(".option-card__radio")) return;
  if ($(e.target).closest("[data-edit-saved-address]").length) return;
  var $radio = $(this).find(".option-card__radio");
  $radio.prop("checked", true).trigger("change");
});
